//export const URI =  'http://localhost:5000/';

//server droplet
export const URI =  '/';

const API_URL = {
   
    'POST_ADMIN_LOGIN': URI + 'api/adminuser/login',
    'POST_ADMIN_CREATE': URI + 'api/adminuser/create',
    'GET_ADMIN_ALL': URI + 'api/adminuser/',
    'DELETE_ADMIN': URI + 'api/adminuser/',

     // Hikmat

     'POST_HIKMAT_MESSAGE':
     URI + 'api/ai/conversation/message',

 }

Object.freeze(API_URL);

export default API_URL;
